/*This file was generated by Fumadocs. Do not edit this file directly. Any changes should be made by running the generation command again.*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Record an artifacts cache usage event",
  "description": "Records an artifacts cache usage event. The body of this request is an array of cache usage events. The supported event types are `HIT` and `MISS`. The source is either `LOCAL` the cache event was on the users filesystem cache or `REMOTE` if the cache event is for a remote cache. When the event is a `HIT` the request also accepts a number `duration` which is the time taken to generate the artifact in the cache.",
  "full": true,
  "_openapi": {
    "method": "POST",
    "route": "/v8/artifacts/events",
    "toc": [],
    "structuredData": {
      "headings": [],
      "contents": [{
        "content": "Records an artifacts cache usage event. The body of this request is an array of cache usage events. The supported event types are `HIT` and `MISS`. The source is either `LOCAL` the cache event was on the users filesystem cache or `REMOTE` if the cache event is for a remote cache. When the event is a `HIT` the request also accepts a number `duration` which is the time taken to generate the artifact in the cache."
      }]
    }
  }
};
export let structuredData = {
  "contents": [{
    "content": "Records an artifacts cache usage event. The body of this request is an array of cache usage events. The supported event types are `HIT` and `MISS`. The source is either `LOCAL` the cache event was on the users filesystem cache or `REMOTE` if the cache event is for a remote cache. When the event is a `HIT` the request also accepts a number `duration` which is the time taken to generate the artifact in the cache."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const {APIPage} = props.components || ({});
  if (!APIPage) _missingMdxReference("APIPage", true);
  return _jsxs(_Fragment, {
    children: ["\n", _jsx(APIPage, {
      document: "./.openapi.json",
      operations: [{
        "path": "/v8/artifacts/events",
        "method": "post"
      }],
      webhooks: [],
      hasHead: false
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
